import React from 'react';
import { EmployerInquiryForm } from '../forms/EmployerInquiryForm';
type EmployerInquiryPanelProps = {
  formId?: string;
};
export function EmployerInquiryPanel({
  formId
}: EmployerInquiryPanelProps) {
  return <div id="employer-inquiry" className="scroll-mt-28 border border-line bg-white p-6 sm:p-10" data-id="element-274" data-mp="ck63gm2rj75v">
      <h3 className="font-serif text-[1.9rem] font-medium leading-tight text-navy" data-id="element-275" data-mp="hlbxcn85t0gz">Hiring inquiry</h3>
      <p className="mt-2 text-[15px] leading-relaxed text-muted" data-id="element-276" data-mp="lkuhhgs5p7ir">
        Share a few details and a member of our team will arrange a confidential conversation.
      </p>
      <div className="mt-8" data-id="element-277" data-mp="vb5ojc74zwtv">
        <EmployerInquiryForm formId={formId} data-id="element-278" data-mp="vd0bew1yxz0l" />
      </div>
    </div>;
}